import { useEffect, useState } from "react";
import fetchStatus from "src/utils/api/fetch-status";
import useAbortableStreamFetch from "../../../utils/request/use-abortable-stream-fetch";

const useApi = (
    requestMethodMock,
    requestMethodActual,
    requiredIntegrations,
    streamURL,
    queryParams
) => {
    const [state, setState] = useState({
        status: fetchStatus.PENDING,
        data: null,
        errorCode: null,
        string: "",
    });

    const fetchFromApi = async (requestMethod, controller) => {
        try {
            const response = await requestMethod({
                queryParams,
                abortController: controller,
            });
            setState((prevState) => ({
                ...prevState,
                status: fetchStatus.SUCCESS,
                data: response,
                errorCode: null,
                controller: null,
            }));
        } catch (e) {
            setState((prevState) => ({
                ...prevState,
                status: fetchStatus.ERROR,
                data: null,
                errorCode: e.status,
                controller: null,
            }));
        }
    };

    // eslint-disable-next-line consistent-return
    const fetchEffect = (controller) => {
        const actualController = controller || new AbortController();
        if (process.env.MOCK_WORK === "true") return fetchFromApi(requestMethodMock);
        if (streamURL) {
            setState((prevState) => ({
                ...prevState,
                data: null,
                string: "",
            }));
            useAbortableStreamFetch(streamURL, state, actualController, setState, queryParams);
        } else {
            fetchFromApi(requestMethodActual, actualController);
        }
    };

    const refetch = (controller) => {
        if (state.controller) {
            state.controller.abort("unmounted");
        }
        setState((prevState) => ({
            ...prevState,
            status: fetchStatus.REFETCHING,
            controller,
        }));
        return fetchEffect(controller);
    };

    useEffect(() => {
        const controller = new AbortController();
        refetch(controller);
        return () => {
            if (controller) {
                controller.abort("unmounted");
            }
        };
    }, [streamURL, queryParams]);

    useEffect(() => {
        return () => {
            if (state.controller) {
                state.controller.abort("unmounted");
            }
        };
    }, []);

    return {
        ...state,
        refetch,
    };
};

export default useApi;
